import { render } from "./aProfileItemLink.vue?vue&type=template&id=9408ae5a"
import script from "./aProfileItemLink.vue?vue&type=script&lang=js"
export * from "./aProfileItemLink.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__